import { combineReducers } from 'redux';
import profile from './profile';
import attributes from './attributes';
import profileOptions from './profileOptions';
import emailAddresses from './emailAddresses';
import notifications from './notifications';
import hubUsers from './hubUsers';
import avatar from './avatar';
export default combineReducers({
  profile,
  attributes,
  emailAddresses,
  profileOptions,
  notifications,
  hubUsers,
  avatar
});